import * as React from 'react'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'

interface Props {
  isSaving: boolean
  locationId?: number
  onClick: () => void
}

const SaveButton = (props: Props): JSX.Element => {
  const determineTitle = (): string => {
    if (!props.locationId) {
      return 'Location required'
    } else if (props.isSaving) {
      return 'Saving...'
    } else {
      return 'Save'
    }
  }

  const title = determineTitle()

  const isDisabled = !props.locationId || props.isSaving

  return (
    <BlazeButton
      titleProps={{ title }}
      buttonProps={{
        onClick: props.onClick,
        disabled: isDisabled,
        loading: props.isSaving,
        type: 'primary',
        className: 'w-100',
      }}
    />
  )
}

export default SaveButton
